import { emptyDraft, type ComposerDraft } from './core'

/**
 * The Message being written in each trip's Chat, kept for as long as the tab lives, so
 * leaving the Chat for a detail page and coming back with "Chat about this" finds the
 * text, tags and photos where they were — as iOS keeps them on its Chat tab. Never stored.
 */
const drafts = new Map<string, ComposerDraft>()

export const readDraft = (tripId: string): ComposerDraft => drafts.get(tripId) ?? emptyDraft()

export const writeDraft = (tripId: string, draft: ComposerDraft): void => {
	drafts.set(tripId, draft)
}
